import * as types from './constants';
import { assignTabDataAndDispatch } from '../../actions';

export function setIsTabActive(tabIndex, isActive) {
  return assignTabDataAndDispatch(
    { type: types.SET_IS_ACTIVE, isActive },
    tabIndex
  );
}
